import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { FormikProps } from "formik";

import { AddButton } from "common/components/AddButton/AddButton";
import { useAppDialog } from "hooks/useAppDialog";
import { useUpdateSelectedOrganizationApiToken } from "hooks/useUpdateSelectedOrganizationApiToken";
import { OrganizationApiToken } from "types/Organization";
import { AddSettingsForm, FormValues } from "./AddSettingsForm";

interface AddSettingsProps {
  token: OrganizationApiToken;
}

export const AddSettings = ({ token }: AddSettingsProps): JSX.Element => {
  const { openDialog, Dialog, dialogProps, closeDialog } = useAppDialog();
  const { t } = useTranslation();
  const { isSuccess, onUpdateApiToken, isLoading } =
    useUpdateSelectedOrganizationApiToken({
      tokenId: token.id,
    });
  const formRef = useRef<FormikProps<FormValues>>(null);

  const onSubmit = () => {
    formRef.current?.handleSubmit();
  };

  useEffect(() => {
    if (isSuccess) {
      closeDialog();
    }
  }, [isSuccess, closeDialog]);

  return (
    <>
      <AddButton variant="contained" onClick={openDialog}>
        {t("AddSetting")}
      </AddButton>
      <Dialog
        title={t("AddSetting")}
        loading={isLoading}
        onSubmit={onSubmit}
        actionText={t("Save")}
        maxWidth="sm"
        {...dialogProps}
      >
        <AddSettingsForm
          formRef={formRef}
          onSubmit={onUpdateApiToken}
          token={token}
        />
      </Dialog>
    </>
  );
};
